// «Мой профиль» — self-service профиль текущего сотрудника.
import { api } from '@/lib/api';
import type { UserRole } from '@/lib/auth-context';

export interface MyProfile {
  employee_id: string;
  role: UserRole;
  first_name: string;
  last_name: string;
  middle_name: string | null;
  phone: string | null;
  email: string | null;
  birth_date: string | null;
  gender: 'm' | 'f' | null;
  photo_url: string | null;
  branch_names: string[];
}

export interface UpdateMyProfileBody {
  first_name?: string;
  last_name?: string;
  middle_name?: string | null;
  phone?: string | null;
  email?: string | null;
  birth_date?: string | null;
  gender?: 'm' | 'f' | null;
}

export function getMyProfile(): Promise<MyProfile> {
  return api.get<{ profile: MyProfile }>('/me/profile').then((r) => r.profile);
}

export function updateMyProfile(body: UpdateMyProfileBody): Promise<MyProfile> {
  return api.patch<{ profile: MyProfile }>('/me/profile', body).then((r) => r.profile);
}

/**
 * Смена собственного пароля (docs/service/32 Ф5). Эндпоинт тот же, что у
 * принудительной смены временного пароля, — здесь добровольный сценарий.
 * Сессия остаётся живой.
 */
export function changeMyPassword(currentPassword: string, newPassword: string): Promise<void> {
  return api.post<void>('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

/** Загрузка своего фото (multipart, поле `file`). */
export function uploadMyPhoto(file: File): Promise<{ photo_url: string }> {
  const fd = new FormData();
  fd.append('file', file);
  return api.post<{ photo_url: string }>('/me/photo', fd);
}
